const preventRightClick = (e: any) => {
    if (e.button === 2) {
        e.preventDefault()
        return false;
    }
}

export default preventRightClick;
